import { render, staticRenderFns } from "./sale_receive_two.vue?vue&type=template&id=2832e849&scoped=true&"
import script from "./sale_receive_two.vue?vue&type=script&lang=js&"
export * from "./sale_receive_two.vue?vue&type=script&lang=js&"
import style0 from "./sale_receive_two.vue?vue&type=style&index=0&id=2832e849&scoped=true&lang=less&"
import style1 from "./sale_receive_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832e849",
  null
  
)

export default component.exports